import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { SelectorSimpleFactory } from "../logic";

const StatusCamion = (props: { value: models.StatusCamionRutaViewDto | null }) => {
    const x = props.value;
    if (x == null) return <span style={{ fontStyle: "italic", color: "red" }}  >Sin status</span>;
    const datos =
        [x.NombreSucursal, x.NombreViaje ? (x.NombreViajeSucursalOrigen + " - " + x.NombreViajeSucursalDestino) : undefined]
            .filter(x => !!x).join(", ");

    const ban = <i className={fa("ban")} />;
    return (
        <div>
            <span style={{ fontStyle: "italic" }} > {datos}</span>
        </div>
    )
}

export class CamionItem extends React.PureComponent<{ value: models.CamionDTO }> {
    render() {
        const x = this.props.value;


        return (
            <div>
                {x.Nombre}
                <br />
                <StatusCamion value={x.UltimoStatus} />
            </div>
        )
    }
}

export const Camion = SelectorSimpleFactory(observeResource(resources.Camion.query), x => x.IdRegistro, x => ({
    label: x.Nombre,
    view: <CamionItem value={x} />
}));



// WEBPACK FOOTER //
// ./app/features/selectores/items/camion.tsx